import React, { useEffect, useState } from "react";
import toLocale from "../../Utils/ToLocaleString";
import ModalidadePg from "./ModalidadePg";
import { Divider } from "antd";
import { LabelPadrao } from "../../components/Base";
import roundCustom from "../../Utils/RoundCustom";
import { InputNumero, InputNumeroPercent } from "../../components/InputNumero";
import { SwapOutlined } from "@ant-design/icons";
import getCssVariable from "../../Utils/getCssVariable";

export default function Pagamento({ pg, setPg, totais, disabled, hideOperacoes, clienteId, tipo, extra, isEntrega, onValorMaximoEnter, tabIndex = 30 }) {

    return <div style={{ width: "100%", display: "flex", justifyContent: "space-between", minHeight: 200 }}>
        <div style={{ width: "40%", marginRight: 10, justifyContent: "space-between", display: "flex" }}>
            <div style={{ width: "100%" }}>
                <div style={{ width: "100%", display: "flex", justifyContent: "space-between", borderBottom: "1px solid rgba(0, 0, 0, 0.06)" }}>
                    <LabelPadrao noMargin><b>Valor Bruto:</b></LabelPadrao>
                    <span style={{ fontSize: "1.25em", color: "#999" }}>{toLocale(totais.bruto)}</span>
                </div>
                <div style={{ width: "100%", display: "flex", justifyContent: "space-between", borderBottom: "1px solid rgba(0, 0, 0, 0.06)" }}>
                    <LabelPadrao noMargin><b>Desconto:</b></LabelPadrao>
                    <span style={{ fontSize: "1.25em", color: "#999" }}>{toLocale(totais.desconto)}</span>
                </div>
                {extra}
                <div style={{ width: "100%", display: "flex", justifyContent: "space-between", borderBottom: "1px solid rgba(0, 0, 0, 0.06)", color: getCssVariable("--azul-padrao") }}>
                    <span><b>Total a pagar:</b></span>
                    <span style={{ fontSize: "1.25em" }}>{toLocale(totais.liquido)}</span>
                </div>
                <div style={{ width: "100%", display: "flex", justifyContent: "space-between", color: getCssVariable("--laranja-padrao") }}>
                    <span><b>Troco:</b></span>
                    <span style={{ fontSize: "1.25em" }}>{toLocale(totais.troco)}</span>
                </div>
            </div>
            <Divider type="vertical" style={{ height: "100%" }} />
        </div>
        <div style={{ width: "60%" }}>
            <ModalidadePg
                pg={pg}
                setPg={setPg}
                total={totais.total}
                liquido={totais.liquido}
                clienteId={clienteId}
                tipo={tipo}
                disabled={disabled}
                tabIndex={tabIndex}
                hideOperacoes={hideOperacoes}
                isEntrega={isEntrega}
                onValorMaximoEnter={onValorMaximoEnter}
            />
        </div>
    </div>;
}

export function DescontosVenda({ descontos, setDescontos, liquidoInicial, onBlur, disabled }) {
    return <>
        <div style={{ width: "100%", display: "flex", justifyContent: "space-between", borderBottom: "1px solid rgba(0, 0, 0, 0.06)" }}>
            <LabelPadrao noMargin><b>Desconto final (%)</b></LabelPadrao>
            <InputNumeroPercent value={descontos.descontoVendaPerc} onChange={v => setDescontos({ descontoVendaPerc: v, descontoVenda: v >= 100 ? liquidoInicial : roundCustom(liquidoInicial / 100 * v) })} onBlur={onBlur} max={100} min={0} style={{ width: "50%" }} disabled={disabled} />
        </div>
        <div style={{ width: "100%", display: "flex", justifyContent: "space-between", borderBottom: "1px solid rgba(0, 0, 0, 0.06)" }}>
            <LabelPadrao noMargin><b>Desconto final (R$)</b></LabelPadrao>
            <InputNumero value={descontos.descontoVenda} onChange={v => setDescontos({ descontoVenda: v, descontoVendaPerc: v >= liquidoInicial ? 100 : roundCustom(v * 100 / liquidoInicial) })} onBlur={onBlur} max={liquidoInicial} min={0} style={{ width: "50%" }} disabled={disabled} />
        </div>
    </>;
}

export function ValoresExtrasPagamento({ valoresExtras, setValoresExtras, liquidoInicial, onBlur, limpar, isEntrega, acrescimoDisabled, disabled }) {
    const [isDesconto, setIsDesconto] = useState(true);

    const handleSetIsDesconto = () => {
        const valExtras = { ...valoresExtras, descontoVenda: 0, descontoVendaPerc: 0, acrescimo: 0, acrescimoPerc: 0 };
        setValoresExtras(valExtras);
        setIsDesconto(!isDesconto);
        limpar();
    };

    useEffect(() => {
        if (isDesconto && valoresExtras.acrescimo != 0)
            setIsDesconto(false);

    }, [valoresExtras]);

    return <>
        {isDesconto ? <>
            <div style={{ width: "100%", display: "flex", justifyContent: "space-between", borderBottom: "1px solid rgba(0, 0, 0, 0.06)" }}>
                <LabelPadrao noMargin><b>Desconto final (%) {(!acrescimoDisabled && !disabled) && <SwapOutlined onClick={handleSetIsDesconto} />}</b></LabelPadrao>
                <InputNumeroPercent value={valoresExtras.descontoVendaPerc} onChange={v => setValoresExtras({ ...valoresExtras, descontoVendaPerc: v, descontoVenda: v >= 100 ? liquidoInicial : roundCustom(liquidoInicial / 100 * v) })} onBlur={onBlur} max={100} min={0} style={{ width: "50%" }} disabled={disabled} />
            </div>
            <div style={{ width: "100%", display: "flex", justifyContent: "space-between", borderBottom: "1px solid rgba(0, 0, 0, 0.06)" }}>
                <LabelPadrao noMargin><b>Desconto final (R$)</b></LabelPadrao>
                <InputNumero value={valoresExtras.descontoVenda} onChange={v => setValoresExtras({ ...valoresExtras, descontoVenda: v, descontoVendaPerc: v >= liquidoInicial ? 100 : roundCustom(v * 100 / liquidoInicial) })} onBlur={onBlur} max={liquidoInicial} min={0} style={{ width: "50%" }} disabled={disabled} />
            </div>
        </> : <>
            <div style={{ width: "100%", display: "flex", justifyContent: "space-between", borderBottom: "1px solid rgba(0, 0, 0, 0.06)" }}>
                <LabelPadrao noMargin><b>Acréscimo (%) {(!acrescimoDisabled && !disabled) && <SwapOutlined onClick={handleSetIsDesconto} />}</b></LabelPadrao>
                <InputNumeroPercent value={valoresExtras.acrescimoPerc} onChange={v => setValoresExtras({ ...valoresExtras, acrescimoPerc: v, acrescimo: roundCustom(liquidoInicial / 100 * v) })} onBlur={onBlur} min={0} style={{ width: "50%" }} disabled={disabled} />
            </div>
            <div style={{ width: "100%", display: "flex", justifyContent: "space-between", borderBottom: "1px solid rgba(0, 0, 0, 0.06)" }}>
                <LabelPadrao noMargin><b>Acréscimo (R$)</b></LabelPadrao>
                <InputNumero value={valoresExtras.acrescimo} onChange={v => setValoresExtras({ ...valoresExtras, acrescimo: v, acrescimoPerc: roundCustom(v * 100 / liquidoInicial) })} onBlur={onBlur} min={0} style={{ width: "50%" }} disabled={disabled} />
            </div>
        </>}

        {isEntrega && <div style={{ width: "100%", display: "flex", justifyContent: "space-between", borderBottom: "1px solid rgba(0, 0, 0, 0.06)" }}>
            <LabelPadrao noMargin><b>Frete (R$)</b></LabelPadrao>
            <InputNumero value={valoresExtras.valorFrete} onChange={v => setValoresExtras({ ...valoresExtras, valorFrete: v })} onBlur={onBlur} min={0} style={{ width: "50%" }} disabled={disabled} />
        </div>}
    </>;
}